var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrag6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 43,
    viewBox: "0 0 30 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63017 42.2886L2.11353 41.3701C-0.92428 35.9876 -0.667102 28.9104 2.75417 23.7598C4.97225 20.421 8.45551 17.9915 12.3039 16.8916C12.5807 14.8702 13.1549 12.9009 14.0076 11.0475C16.2824 6.16577 20.3481 2.34651 25.3621 0.381193L26.3426 0L27.1026 1.96105L26.1221 2.33994C21.6145 4.10637 17.9596 7.54022 15.9157 11.9293C15.2565 13.3585 14.7834 14.8665 14.5082 16.4162C15.908 16.2069 17.3292 16.1823 18.7354 16.3428C23.5366 16.8985 27.571 19.7252 29.0153 23.5393C29.8717 25.8104 29.6192 28.605 28.354 30.8347C27.2426 32.7888 25.532 34.0495 23.5321 34.4146C18.8548 35.2459 14.8067 31.1148 13.243 26.6072C12.4121 24.2105 12.0269 21.6819 12.1064 19.1465C9.00619 20.1891 6.33268 22.2183 4.49464 24.924C1.50964 29.4316 1.28004 35.6248 3.93669 40.339L4.45103 41.2576L2.63017 42.2886ZM14.2441 18.5885C14.086 21.0736 14.424 23.5652 15.2384 25.9183C16.4852 29.4959 19.6906 32.9633 23.1738 32.3479C24.5378 32.1183 25.7295 31.1998 26.5263 29.799C27.4906 28.1021 27.6904 25.9895 27.0475 24.2879C25.881 21.1994 22.5217 18.9031 18.4943 18.4347C17.0776 18.2747 15.645 18.3282 14.2441 18.5931V18.5885Z",
    fill: "#496EF3",
    fillOpacity: 0.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrag6);
export default __webpack_public_path__ + "static/media/frag6.3d4712001ead9e88f76e0343c355ce43.svg";
export { ForwardRef as ReactComponent };